<template>
    <form class="cbs-passenger-details-form" v-on:submit.prevent>
        <div class="row">
            <div class="col-md-6 col-12">
                <div class="cbs-passenger-details-form-passenger-title">
                    <label class="check">
                        <input type="radio" name="passengerTitle" value="Mr." v-model="salutation" />
                        <span class="checkmark"></span> {{$t('forms.passengerDetails.mrLabel')}}
                    </label>
                    <label class="check">
                        <input type="radio" name="passengerTitle" value="Ms." v-model="salutation" />
                        <span class="checkmark"></span> {{$t('forms.passengerDetails.msLabel')}}
                    </label>
                </div>
            </div>
            
            <div class="col-md-6 col-12" v-if="!this.hideMeetAndGreet">
                <div class="cbs-passenger-details-form-passenger-title">
                <label class="check">
                    <input type="checkbox" name="hasMeetAndGreet" v-model="hasMeetAndGreet"/>
                    <span class="checkmark"></span> Add Meet & Greet service
                </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 form-group">
                <!--<label for="contact:name">First Name *</label>-->
                <input type="text" class="form-control" name="firstName" :placeholder="$t('forms.passengerDetails.firstNamePlaceholder')"
                       :value="firstName" @input="updateField('firstName', $event)" :class="{ error: $v.firstName.$error }">
                <div v-if="$v.firstName.$dirty">
                    <div class="error-message" v-if="!$v.firstName.required">First name is required.</div>
                </div>
            </div>

            <div class="col-md-6 form-group">
                <!--<label for="contact:name">Last Name *</label>-->
                <input type="text" class="form-control" name="lastName" :placeholder="$t('forms.passengerDetails.lastNamePlaceholder')"
                       :value="lastName" @input="updateField('lastName', $event)" :class="{ error: $v.lastName.$error }">
                <div v-if="$v.lastName.$dirty">
                    <div class="error-message" v-if="!$v.lastName.required">Last name is required.</div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <!--<label for="contact:email">E-mail Address v-model.trim="email"  *</label>-->
                <input type="email" class="form-control" name="email" :placeholder="$t('forms.passengerDetails.emailPlaceholder')"
                       :value="email" @input="updateField('email', $event)" :class="{ error: $v.email.$error }">
                <div v-if="$v.email.$dirty">
                    <div class="error-message" v-if="!$v.email.email">Email address is not valid. Keep typing...</div>
                    <div class="error-message" v-if="$v.email.$dirty && !$v.email.required">Email address is required.</div>
                </div>
            </div>

            <div class="col-md-6 form-group">
                <!-- <vue-tel-input class="form-control" v-model="phoneNumber">
                </vue-tel-input> -->
                <vue-tel-input v-model="phoneNumber" @input="onPhoneInput" :placeholder="$t('forms.passengerDetails.phonePlaceholder')"
                    :enabledFlags="true" inputClasses="form-control" :preferredCountries="['ch','be']">
                </vue-tel-input>
                <div v-if="$v.phone.$dirty">
                    <div class="error-message" v-if="!$v.phone.required">Phone number is require in case chauffeur needs to contact you.</div>
                </div>
            </div>
        </div>

        <div class="row" v-show="this.showNumberOfDrivers && isDrivano">
            <div class="col-md-6 form-group">
                <div class="d-flex h-100">
                    <div>
                        <label for="smallChildrenNumber" class="mt-2 pr-2">Drivers: </label>
                    </div>
                    <div class="w-100">
                        <NumberInputSpinner class="d-flex ml-2" :min="1" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                        name="driversNumber" title="Drivers Number" placeholder="Drivers number"
                                        :value="numberOfCars" ref="driversNumberSpinner" @input="updateNumberOfCars($event)" />
                    </div>
                </div>
            </div>
            <div class="col-md-6 form-group">
                <div class="d-flex h-100">
                    <div>
                        <label for="smallChildrenNumber" class="mt-2 pr-2" style="white-space: nowrap;">Referred By: </label>
                    </div>
                    <div class="w-100">
                        <input type="text" class="d-flex form-control"
                            :value="referredBy" @input="updateField('referredBy', $event)"
                            name="referredBy" title="Referred by driver" placeholder="Driver name"
                         />
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row" v-show="showCarToDrive && isDrivano">
            <div class="col-md-12 form-group">
                <div class="d-flex h-100">
                    <div>
                        <label for="smallChildrenNumber" class="mt-2 pr-2" style="white-space: nowrap;">Car to drive: </label>
                    </div>
                    <div class="w-100">
                        <input type="text" class="d-flex form-control"
                            :value="carToDrive" @input="updateField('carToDrive', $event)"
                            name="carToDrive" title="What car will the driver drive" placeholder="Car that will be driven by driver"
                         />
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="this.selectedCar.messages.length > 0">
            <div class="col">
                <ul class="list-unstyled booking-notifications">
                    <li v-for="item in this.selectedCar.messages" :class="item.type" :key="item.i18Key" v-html="item.htmlMessage"></li>
                </ul>
            </div>
        </div>

        <div class="row mb-3" v-show="showSpecialOffersButton">
            <div class="col text-center">
                <button type="button" class="btn btn-sm btn-primary" @click="showSpecialOffers = !showSpecialOffers">{{$t('forms.passengerDetails.specialOffers')}}</button>                    
            </div>
        </div>
        <div class="row mt-2" v-show="showSpecialOffers">
            <!--https://bootsnipp.com/snippets/vN2mb-->
            <!-- Card #1, Bronze -->
            <div class="col-lg-4 col-md-6 col-sm-10 pb-4 d-block m-auto">
                <div class="pricing-item" style="box-shadow: 0px 0px 30px -7px rgba(0,0,0,0.29);">
                    <!-- Indicator of subscription type -->
                    <div class="pt-4 pb-3" style="letter-spacing: 2px">
                        <h4>Bronze</h4>
                    </div>
                    <!-- Price class -->
                    <div class="pricing-price pb-1 text-primary color-primary-text ">
                        <h1 style="font-weight: 600; font-size: 2.5em;">
                            <span style="   font-size: 20px;">CHF</span>2160
                        </h1>
                    </div>
                    <!-- Perks of said subscription -->
                    <div class="pricing-description">
                        <ul class="list-unstyled mt-3 mb-4">
                            <li class="pl-3 pr-3"><span v-html="$t('forms.passengerDetails.offerText', {hours: 50, hourlyRate: 43.2})"></span></li>
                        </ul>
                        <h3 style="font-size: 24px;">4% {{$t('forms.passengerDetails.offerReduction')}}</h3>
                    </div>
                    <!-- Button -->
                    <div class="pricing-button pb-4">
                        <button type="button" class="btn btn-lg btn-primary w-75" @click="setOffer('bronze')">{{$t('forms.passengerDetails.offerTake')}}</button>
                    </div>
                </div>
            </div>

            <!-- Card #2, Silver -->
            <div class="col-lg-4 col-md-6 col-sm-10 pb-4 d-block m-auto">
                <div class="pricing-item" style="box-shadow: 0px 0px 30px -7px rgba(0,0,0,0.29);">
                    <div class="pt-4 pb-3" style="letter-spacing: 2px">
                        <h4>Silver</h4>
                    </div>
                    <div class="pricing-price pb-1 text-primary color-primary-text ">
                        <h1 style="font-weight: 600; font-size: 2.5em;">
                            <span style="font-size: 18px;">CHF</span>5000
                        </h1>
                    </div>
                    <div class="pricing-description">
                        <ul class="list-unstyled mt-3 mb-4">
                            <li class="pl-3 pr-3"><span v-html="$t('forms.passengerDetails.offerText', {hours: 100, hourlyRate: 41.4})"></span></li>
                        </ul>
                        <h3 style="font-size: 24px;">8% {{$t('forms.passengerDetails.offerReduction')}}</h3>
                    </div>
                    <div class="pricing-button pb-4">
                        <button type="button" class="btn btn-lg btn-primary w-75" @click="setOffer('silver')">{{$t('forms.passengerDetails.offerTake')}}</button>
                    </div>
                </div>
            </div>

            <!-- Card #3, Gold -->
            <div class="col-lg-4 col-md-6 col-sm-10 pb-4 d-block m-auto">
                <div class="pricing-item" style="box-shadow: 0px 0px 30px -7px rgba(0,0,0,0.29);">
                    <div class="pt-4 pb-3" style="letter-spacing: 2px">
                        <h4>Gold</h4>
                    </div>
                    <div class="pricing-price pb-1 text-primary color-primary-text ">
                        <h1 style="font-weight: 600; font-size: 2.5em;">
                            <span style="font-size: 20px;">CHF</span>7920
                        </h1>
                    </div>
                    <div class="pricing-description">
                        <ul class="list-unstyled mt-3 mb-4">
                            <li class="pl-3 pr-3"><span v-html="$t('forms.passengerDetails.offerText', {hours: 200, hourlyRate: 39.6})"></span></li>
                        </ul>
                        <h3 style="font-size: 24px;">12% {{$t('forms.passengerDetails.offerReduction')}}</h3>
                    </div>
                    <div class="pricing-button pb-4">
                        <button type="button" class="btn btn-lg btn-primary w-75" @click="setOffer('gold')">{{$t('forms.passengerDetails.offerTake')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4 justify-content-center" v-if="this.offer != null && this.selectedCar.discountPercentage > 0">
            <div class="col-md-8 ">
                <p class="text-center" v-html="$t('forms.passengerDetails.offerDescription', {discount: this.selectedCar.discountPercentage})">
                </p>
                <button type="button" class="btn btn-sm btn-danger" @click="setOffer(null)">{{$t('forms.passengerDetails.offerRemove')}}</button>
            </div>
        </div>

        <div class="row" v-if="!this.hidePassengers">
            <div class="col-md-6 form-group">
                <!--<label for="smallChildrenNumber">Adults number</label>-->
                <NumberInputSpinner :min="1" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="adultsNumber" title="Adults Number" placeholder="Passengers"
                                    :value="adultsNumber" @input="updateSpinner('adultsNumber', $event)"
                                    :class="{ error: $v.adultsNumber.$error }" />
                <div>How many passengers? (including children)</div>
                <div class="error-message" v-if="$v.adultsNumber.$dirty && !$v.adultsNumber.isAdultsNumberRequired">Passengers number must be positive.</div>
            </div>

            <!--<div class="col-md-4">
                <label for="smallChildrenNumber">Children > 7 years</label>
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true"
                                    buttonClass="vnis__button btn-spinner"
                                    name="childrenNumber" title="Children younger than 7"
                                    placeholder="Children younger than 7"
                                    :value="childrenNumber" @input="updateSpinner('childrenNumber', $event)"
                                    :class="{ error: $v.childrenNumber.$error }" />
                <div v-if="$v.childrenNumber.$dirty">
                    <div class="error-message" v-if="!$v.childrenNumber.required">Children older than 7 is required.</div>
                </div>
            </div>-->

            <div class="col-md-6 form-group">
                <!--<label for="smallChildrenNumber">Children < 7 years</label>-->
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="childrenNumber" title="Child seats number" placeholder="Child seats"
                                    :value="childrenNumber" @input="updateSpinner('childrenNumber', $event)"/>
                                    <!-- :class="{ error: $v.childrenNumber.$error }" /> -->
                <div><p>How many child seats are required?</p></div>
                <!-- <div v-if="$v.childrenNumber.$dirty">   //For now child number is nor required
                    <div class="error-message" v-if="!$v.childrenNumber.required">Child seats number is required.</div>
                </div> -->
            </div>
            <!--<div class="col-sm-12">
                <p>Passengers number is Adults </p>
            </div>-->
            <!--<div class="col-md-4 form-group">
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="luggageNumber" title="Luggage number" placeholder="Luggage number"
                                    :value="luggageNumber" @input="updateSpinner('luggageNumber', $event)"
                                    :class="{ error: $v.luggageNumber.$error }" />
                <div v-if="$v.luggageNumber.$dirty">
                    <div class="error-message" v-if="!$v.luggageNumber.required">Luggage number is required.</div>
                </div>
            </div>-->
            <!--
            //TODO: maybe add these as errors on check prices page .. or warnings     
            -->
            <div class="col-12">
                <div class="text-danger text-center mt-10" v-show="exceedCapacity">
                    Number of persons exceed car capacity. Please select different vehicle or make multiple reservations.
                </div>
            </div>
        </div>

        <div class="row" v-if="!this.hideFlightInfo">
            <div class="col-12 cbs-passenger-details-form-passenger-title">
                <label class="check">
                    <input type="checkbox" name="arrivingByPlane" v-model="arrivingByPlane" />
                    <span class="checkmark"></span> Arriving by plane
                </label>
            </div>
        </div>

        <div class="row" v-if="!this.hideFlightInfo" v-show="arrivingByPlane">
            <div class="col-md-4 col-sm-12 form-group">
                <input type="text" class="form-control" name="flightNumber" placeholder="Flight number"
                       :value="flightNumber" @input="updateField('flightNumber', $event)">
                <div class="error-message" v-show="$v.flightNumber.$dirty && !$v.flightNumber.isFlightInfoRequired">
                    Please enter flight number.
                </div>
            </div>
            <div class="col-md-4 col-sm-12 form-group">
                <input type="text" class="form-control" name="comingFrom" placeholder="Coming from"
                       :value="comingFrom" @input="updateField('comingFrom', $event)">
                 <div class="error-message" v-show="$v.comingFrom.$dirty && !$v.comingFrom.isFlightInfoRequired">
                    Please enter coming from airport name.
                </div>
            </div>
            <div class="col-md-4 col-sm-12 form-group">
                <input type="text" class="form-control" name="airline" placeholder="Airline"
                       :value="airline" @input="updateField('airline', $event)">
                 <div class="error-message" v-show="$v.airline.$dirty && !$v.airline.isFlightInfoRequired">
                    Please enter airline name.
                </div>
            </div>                       
        </div>

        <div class="row" v-if="!this.hideFlightInfo" v-show="arrivingByPlane">
            <div class="col-md-6 form-group">
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="largeLuggageNumber" title="Checked Luggages" placeholder="Checked Luggages"
                                    :value="largeLuggageNumber" @input="updateSpinner('largeLuggageNumber', $event)" />
            </div>
            <div class="col-md-6 form-group">
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="mediumLuggageNumber" title="Carry-on Luggages" placeholder="Carry-on Luggages"
                                    :value="mediumLuggageNumber" @input="updateSpinner('mediumLuggageNumber', $event)" />
            </div>
        </div>

        <div class="clearfix">
            <textarea maxlength="10000" rows="4" class="form-control" name="passengerDriverExtraComments" 
                      :placeholder="$t('forms.passengerDetails.driverInstructionsPlaceholder')"
                      :value="driverInstructions" @input="updateField('driverInstructions', $event)"></textarea>
        </div>

        <div class="row mt-3">
            <div class="col-12 cbs-passenger-details-form-passenger-title">
                <label class="check">
                    <input type="checkbox" name="differentBilling" v-model="differentBilling" />
                    <span class="checkmark"></span> {{$t('forms.passengerDetails.billingDetailsLabel')}}
                </label>
            </div>
            <div class="col-12">
                <div v-show="differentBilling">
                    <div class="row ">
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control" name="companyName" 
                                   :placeholder="$t('forms.passengerDetails.billingCompanyNamePlaceholder')"
                                   :value="companyName" @input="updateField('companyName', $event)">
                        </div>
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control" name="companyTaxNumber"
                                :placeholder="$t('forms.passengerDetails.billingCompanyTaxNumberPlaceholder')"
                                :value="companyTaxNumber" @input="updateField('companyTaxNumber', $event)">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control" name="companyAddress"
                                :placeholder="$t('forms.passengerDetails.billingCompanyAddress1Placeholder')"
                                :value="companyAddress" @input="updateField('companyAddress', $event)">
                        </div>
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control" name="companyAdditionalAddress" 
                                :placeholder="$t('forms.passengerDetails.billingCompanyAddress2Placeholder')"
                                :value="companyAdditionalAddress" @input="updateField('companyAdditionalAddress', $event)">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3" v-if="availableTips.length > 0">
            <div class="col-12">
                <ul class="list-inline">
                    <li class="list-inline-item mr-md-3"><strong>Tip (%):</strong></li>
                    <li class="list-inline-item" v-for="tip in availableTips" :key="tip.id">
                        <label class="check">
                            <input type="radio" name="tipValue" :value="tip.id" v-model="bookingTip" />
                            <span class="checkmark"></span>{{tip.id}}
                        </label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="row mt-20">
            <div class="col-md-12">
                <button type="button" class="btn btn-primary float-left" @click="goToCarSelection">{{$t('forms.passengerDetails.changeService')}}</button>
                <button type="button" @click="onSubmit" class="btn btn-primary float-right"> 
                    <div class="spinner-border spinner-border-sm" v-show="isPriceLoading" role="status">
                        <span class="sr-only">{{$t('forms.actions.loading')}}</span>
                    </div>
                    {{$t('forms.passengerDetails.continue')}} 
                </button>
            </div>
        </div>

        <!--
    <div class="validators">
        <pre>{{$v}}</pre>
    </div>
    -->
    </form>
</template>

<script>
    //import 'vue-tel-input/dist/vue-tel-input.css';
    import HtmlPageService from "../../services/htmlPageService";
    import Vue from 'vue';
    import { debounce } from "debounce";
    import VueTelInput from 'vue-tel-input'
    import Vuelidate from 'vuelidate';
    import { required, email } from 'vuelidate/lib/validators';
    import { mapState } from 'vuex';
    import i18n from '../../i18n';

    import NumberInputSpinner from '../vue-number-spinner/vueNumberSpinner.vue'

    Vue.use(Vuelidate);
    Vue.use(VueTelInput);
    
    const isAdultsNumberRequired = (value, vm) =>{
        if(vm.hidePassengers) return true;
        return value > 0;
    }

    const isFlightInfoRequired = (value, vm) =>{
        if(!vm.arrivingByPlane) return true;
        return value != null && value.length > 0;
    }

    export default {
        name: "PassengerDetails",
        data: function () {
            return { 
                showSpecialOffers: false,
                valuePhone: null,
                isPriceLoading: false
            }
        },
        validations: {
            email: { required, email },
            firstName: { required },
            lastName: { required },
            //TODO: fix this for later 
            adultsNumber: { isAdultsNumberRequired },
            //childrenNumber: { },
            phone: { required },
            flightNumber: {isFlightInfoRequired},
            comingFrom: {isFlightInfoRequired},
            airline: {isFlightInfoRequired},
        },
        components: { NumberInputSpinner },
        mounted(){
            //console.log('try to fill data');
            var user = this.$store.state.account;
            if(!this.firstName && user.firstName)
                this.updateFieldwithValue('firstName', user.firstName);
            if(!this.lastName && user.lastName)
                this.updateFieldwithValue('lastName', user.lastName);
            if(!this.email && user.email)
                this.updateFieldwithValue('email', user.email);
            if(!this.phone && user.phone)
                this.updateFieldwithValue('phone', user.phone);

            this.$store.commit("booking/setPassengerLanguage", i18n.locale)
        },
        computed: {           
            isDrivano: function() { 
                return this.$store.state.booking.configuration.isDrivano;
            },
            selectedCar: function(){
                return this.$store.state.booking.bookingInfo.selectedCar;
            },
            showNumberOfDrivers: function(){
                var car = this.$store.state.booking.bookingInfo.selectedCar;
                return car.className.indexOf("Valet Parking") >=0 || true;   // always show number of drivers   
            },
            showSpecialOffersButton: function(){
                return this.$store.state.booking.configuration.showSpecialOffersButton;
            },
            numberOfCars: function() {
                //console.log('updated 1',  this.$refs);
                //use the below to update spinner if model changes 
                if(this.$refs.driversNumberSpinner)
                    this.$refs.driversNumberSpinner.update(this.$store.state.booking.bookingInfo.general.numberOfCars);
                return this.$store.state.booking.bookingInfo.general.numberOfCars;                
            },
            showCarToDrive:  function() {
                console.log("showCarToDrive");
                var car = this.$store.state.booking.bookingInfo.selectedCar;
                return !(car.className.indexOf("Valet Parking") >=0 || car.className.indexOf("Parking attendant") >= 0 || car.className.indexOf("Parking guards") >= 0);
            },
            hideMeetAndGreet: function(){
                 return this.$store.state.booking.configuration.hideMeetAndGreet;
            },
            hidePassengers: function(){
                 return this.$store.state.booking.configuration.hidePassengers;
            },
            hideFlightInfo: function(){
                 return this.$store.state.booking.configuration.hideFlightInfo;
            },
            salutation: {
                get: function () {
                    return this.$store.state.booking.bookingInfo.passengerDetails.salutation;
                },
                set: function (value) {
                    this.$store.commit("booking/setPassengerDetailsProperty", { propertyName: 'salutation', value: value });
                }
            },
            bookingTip: {
                get: function () { return this.$store.state.booking.bookingInfo.general.bookingTip; },
                set: function (value) {
                    this.$store.commit("booking/setBookingTip",value);
                    this.isPriceLoading = true;
                    this.$store.dispatch('booking/updateBookingPrice')
                    .then(()=>{
                        this.isPriceLoading = false;
                    })
                    .catch(()=>{
                        this.isPriceLoading = false;
                    });
                }
            },
            availableTips: function() {
                return this.$store.state.booking.configuration.availableTips;
            },
            hasMeetAndGreet: {
                get: function () {
                    return this.$store.state.booking.bookingInfo.passengerDetails.hasMeetAndGreet;
                },
                set: function (value) {
                    this.updateSpinner('hasMeetAndGreet', value)
                }
            },
            exceedCapacity: function () {
                var adults = this.$store.state.booking.bookingInfo.passengerDetails.adultsNumber;
                if (!adults) adults = 0
                let carCapacity = this.$store.state.booking.bookingInfo.selectedCar.numberOfPassengers;
                if (!carCapacity) carCapacity = 3;
                return adults > carCapacity;
               // var children = this.$store.state.bookingInfo.passengerDetails.childrenNumber;
                //if (!children) children = 0;
                //let carCapacity = this.$store.state.bookingInfo.selectedCar.numberOfPassengers;
                //if (!carCapacity) carCapacity = 3;
               // console.log(carCapacity);
               
            },
            differentBilling: {
                get: function () { return this.$store.state.booking.bookingInfo.passengerDetails.differentBilling; },
                set: function (value) { this.$store.commit("booking/setPassengerDetailsProperty", { propertyName: 'differentBilling', value: value }); }
            },
            arrivingByPlane: {
                get: function () { return this.$store.state.booking.bookingInfo.passengerDetails.arrivingByPlane; },
                set: function (value) { this.$store.commit("booking/setPassengerDetailsProperty", { propertyName: 'arrivingByPlane', value: value }); }
            },
            phoneNumber: {
                get: function () { return this.$store.state.booking.bookingInfo.passengerDetails.phone; },
                set: function() { 
                    //NOTE: update is handled on diferent method
                }
            },
            ...mapState({                
                email: state => state.booking.bookingInfo.passengerDetails.email,
                phone: state => state.booking.bookingInfo.passengerDetails.phone,
                firstName: state => state.booking.bookingInfo.passengerDetails.firstName,
                lastName: state => state.booking.bookingInfo.passengerDetails.lastName,

                adultsNumber: state => state.booking.bookingInfo.passengerDetails.adultsNumber,
                childrenNumber: state => state.booking.bookingInfo.passengerDetails.childrenNumber,
                smallChildrenNumber: state => state.booking.bookingInfo.passengerDetails.smallChildrenNumber,
//                numberOfCars: state => state.booking.bookingInfo.general.numberOfCars,
                offer: state => state.booking.bookingInfo.general.offer,

                flightNumber: state => state.booking.bookingInfo.passengerDetails.flightNumber,
                comingFrom: state => state.booking.bookingInfo.passengerDetails.comingFrom,
                airline: state => state.booking.bookingInfo.passengerDetails.airline,
                roomNumber: state => state.booking.bookingInfo.passengerDetails.roomNumber,
                driverInstructions: state => state.booking.bookingInfo.passengerDetails.driverInstructions,

                //bookingTip: state => state.booking.bookingInfo.general.bookingTip,

                companyName: state => state.booking.bookingInfo.passengerDetails.companyName,
                companyTaxNumber: state => state.booking.bookingInfo.passengerDetails.companyTaxNumber,
                companyAddress: state => state.booking.bookingInfo.passengerDetails.companyAddress,
                companyAdditionalAddress: state => state.booking.bookingInfo.passengerDetails.companyAdditionalAddress,

                largeLuggageNumber: state => state.booking.bookingInfo.passengerDetails.largeLuggageNumber,
                mediumLuggageNumber: state => state.booking.bookingInfo.passengerDetails.mediumLuggageNumber,

                referredBy: state => state.booking.bookingInfo.passengerDetails.referredBy,
                carToDrive: state => state.booking.bookingInfo.passengerDetails.carToDrive
                //hasMeetAndGreet: state => state.bookingInfo.passengerDetails.hasMeetAndGreet,

                //helper properties
                //arrivingByPlane: state => state.bookingInfo.passengerDetails.arrivingByPlane,
                //differentBilling: state => state.bookingInfo.passengerDetails.differentBilling,
                //isLoading: state => state.bookingInfo.passengerDetails.isLoading,

                //isPriceLoading: state => state.booking.bookingInfo.general.isPriceLoading
            })
        },
        methods: {
            setOffer:function  (value) {
                console.log("set offer", this);
                this.$store.commit("booking/setOffer", value);
                this.$store.dispatch('booking/updateBookingPrice')
                    .then(()=>{
                        this.isPriceLoading = false;
                    })
                    .catch(()=>{
                        this.isPriceLoading = false;
                    });
            },
            requiredIfEnabled: (value) => {
                return !this.hidePassengers || required(value);
            },

            onPhoneInput(inputText, numberInfo) {
                if (numberInfo.isValid) {
                    this.updateFieldwithValue('phone', numberInfo.number.international);
                }
            },
            updateSpinner(name, value) {
                console.log('spinner update ' + name + " value " + value);
                if(name == "adultsNumber" && value == 0) value = null;

                this.$store.commit("booking/setPassengerDetailsProperty", { propertyName: name, value: value });
                if (name === 'childrenNumber' || name === 'hasMeetAndGreet' || name === 'driversNumber'){
                    this.isPriceLoading = true;
                    this.$store.dispatch('booking/updateBookingPrice')
                        .then(()=>{
                            this.isPriceLoading = false;
                        })
                        .catch(()=>{
                            this.isPriceLoading = false;
                    });
                }

                if (this.$v[name])
                    this.$v[name].$touch();
            },
            updateNumberOfCars: debounce(function(value) {                
                this.$store.commit("booking/setNumberOfCars", value);
                this.isPriceLoading = true;
                this.$store.dispatch('booking/updateBookingPrice')
                    .then(()=>{
                        this.isPriceLoading = false;
                    })
                    .catch(()=>{
                        this.isPriceLoading = false;
                    });
                }, 500),
            updateField(name, e) {
                var valueToSet = e.target.value.trim();
                this.updateFieldwithValue(name, valueToSet);
            },
            updateFieldwithValue(name, valueToSet) {
                this.$store.commit("booking/setPassengerDetailsProperty", { propertyName: name, value: valueToSet });

                if (this.$v[name])
                    this.$v[name].$touch();
            },
            goToCarSelection: function () {
                this.$store.commit("booking/setCurrentStep", 2);
            },
            goToPayment: function () { },
            onSubmit() {
                //console.log('form submitted', this.$v);
                this.$v.$touch();
                this.$store.commit("booking/setPassengerLanguage", i18n.locale)
                
                //if(this.arrivingByPlane && (!this.flightNumber || !this.comingFrom)) return;

                if (this.isPriceLoading || this.exceedCapacity) return;

                if (!this.$v.$invalid) {
                    this.$store.commit("booking/setCurrentStep", 4);
                } else {
                    //scroll to first form error
                    HtmlPageService.scrollElement('.error', 10)
                }
            }
        }
    }
</script>

<style>
    .cbs-passenger-details-form {
        background-color: #fff;
        padding: 20px;
        padding-top: 10px;
    }

    .cbs-passenger-details-form .text-primary {
        color: #AB8B64 !important;
    }
        .cbs-passenger-details-form .checkbox + .checkbox, .cbs-passenger-details-form .radio + .radio {
            margin-top: 0 !important;
        }

        .cbs-passenger-details-form .cbs-passenger-details-form-title {
            font-size: 18px;
            margin-bottom: 5px;
        }

        .cbs-passenger-details-form .cbs-passenger-details-form-passenger-title {
            text-align: left;
        }

        .cbs-passenger-details-form .cbs-passenger-details-form-passenger-title label.checkbox {
            font-weight: normal;
            color: unset;
        }

        .cbs-passenger-details-form .cbs-passenger-details-form-passenger-title .checkmark{
            margin-top: 2px;
        }

        .cbs-passenger-details-form .checkbox input:checked + i {
            border-color: #c6c6c6;
        }

        .cbs-passenger-details-form .checkbox input + i:after {
            color: #7b7b7b;
            top: 2px;
            left: 2px;
        }

        .cbs-passenger-details-form .radio i, .cbs-passenger-details-form .checkbox i {
            width: 21px;
            height: 21px;
            border-width: 1px;
            border-color: #ddd;
        }

        .cbs-passenger-details-form .btn-spinner {
            background-color: white;
            color: black;
            border: 1px solid #ddd;
        }

        .cbs-passenger-details-form input[type=number]::-webkit-outer-spin-button,
        .cbs-passenger-details-form input[type=tel]::-webkit-outer-spin-button,
        .cbs-passenger-details-form input[type=number]::-webkit-inner-spin-button,
        .cbs-passenger-details-form input[type=tel]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
            border-color: #ddd;
        }

        .cbs-passenger-details-form input[type=number],
        .cbs-passenger-details-form input[type=tel] {
            -moz-appearance: textfield;
        }

        .cbs-passenger-details-form input::placeholder {
            color: #6c757d;
            opacity: 1;
        }

        .cbs-passenger-details-form input {
            color: black !important;
        }

        .cbs-passenger-details-form .vnis button {
            border-radius: 0;
            padding: 0;
            display: inline-block;
        }
        .cbs-passenger-details-form .vnis input {
            width: none;
            display: inline-block;
        }

        .cbs-passenger-details-form textarea {
            max-width: 100%;
        }

    .cbs-passenger-details-form .booking-notifications .error {
        color:  #ff0000 !important;
    }

    .cbs-passenger-details-form .booking-notifications .warning {
        color: #f17237!important;
    }

    .error-message {
        color: #ff0000;
        font-size: 12px;
        margin-top: 3px;
    }
</style>